/* bsb-custom-ball.js — canvas ball preview + cart.
   Sport/size/price/variant data flows from the #bsb-cb-data island and
   data-* attrs on the radio inputs (mirrors bsb-product-info.js / bsb-color-swatches).
   No hardcoded option, image, or variant maps. */

(function () {
  'use strict';

  const dataEl = document.getElementById('bsb-cb-data');
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (err) {
    console.warn('[bsb-cb] Failed to parse configurator data island:', err);
    return;
  }

  /* Lazy-loads a third-party script once, caching the in-flight promise so
     concurrent callers share one <script> tag instead of injecting duplicates.
     pdf.js is ~340KB and only needed once a customer actually uploads a PDF
     logo (for the canvas preview) — not on every page load of this section. */
  const scriptPromises = {};
  function loadScript(src) {
    if (scriptPromises[src]) return scriptPromises[src];
    scriptPromises[src] = new Promise((resolve, reject) => {
      const el = document.createElement('script');
      el.src = src;
      el.onload = () => resolve();
      el.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.head.appendChild(el);
    });
    return scriptPromises[src];
  }

  const variants = data.variants || [];
  const sportPos = data.sportPos != null ? data.sportPos + 1 : null;
  const sizePos  = data.sizePos  != null ? data.sizePos  + 1 : null;
  const doubleSidedPct = data.doubleSidedPct || 0;
  const bothSidesPct   = data.bothSidesPct || 0;
  const displayNotes   = data.displayNotes || {};
  const bundleMinMode  = data.bundleMinMode || 'qty';
  const logoPreviewUnsupportedMessage = data.logoPreviewUnsupportedMessage || 'No preview for this file type — drag to position your logo';

  const canvas = document.getElementById('bsb-cb-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  const sportsFieldset = document.getElementById('bsb-cb-sports');
  const sizesFieldset  = document.getElementById('bsb-cb-sizes');
  const priceEl = document.getElementById('bsb-cb-price');
  const totalPriceEl = document.getElementById('bsb-cb-total-price');
  const doubleSidedToggle = document.getElementById('bsb-cb-double-sided');
  const displayMethodSelect = document.getElementById('bsb-cb-display-method');
  const displayNoteEl = document.getElementById('bsb-cb-display-note');
  const safeZoneToggle = document.getElementById('bsb-cb-safe-zone');
  const fileInput = document.getElementById('bsb-cb-file-input');
  const uploadArea = document.getElementById('bsb-cb-upload-area');
  const uploadPreview = document.getElementById('bsb-cb-upload-preview');
  const previewThumb = document.getElementById('bsb-cb-preview-thumb');
  const previewIcon = document.getElementById('bsb-cb-preview-icon');
  const fileNameEl = document.getElementById('bsb-cb-file-name');
  const removeFileBtn = document.getElementById('bsb-cb-remove-file');
  const fileQualityEl = document.getElementById('bsb-cb-file-quality');
  const logoControls = document.getElementById('bsb-cb-logo-controls');
  const logoSizeInput = document.getElementById('bsb-cb-logo-size');
  const logoSizeLabel = document.getElementById('bsb-cb-logo-size-label');
  const textInput = document.getElementById('bsb-cb-text-input');
  const fontSelect = document.getElementById('bsb-cb-font');
  const textColorInput = document.getElementById('bsb-cb-text-color');
  const textSizeInput = document.getElementById('bsb-cb-text-size');
  const qtyInput = document.getElementById('bsb-cb-qty-input');
  const qtyMinus = document.getElementById('bsb-cb-qty-minus');
  const qtyPlus = document.getElementById('bsb-cb-qty-plus');
  const addToBundleBtn = document.getElementById('bsb-cb-add-to-bundle');
  const conflictEl = document.getElementById('bsb-cb-conflict');
  const conflictKeepLogoBtn = document.getElementById('bsb-cb-conflict-keep-logo');
  const conflictKeepTextBtn = document.getElementById('bsb-cb-conflict-keep-text');
  const atcBtn = document.getElementById('bsb-cb-atc');
  const bundleListEl = document.getElementById('bsb-cb-bundle-list');
  const bundleCountEl = document.getElementById('bsb-cb-bundle-count');
  const bundleTotalsEl = document.getElementById('bsb-cb-bundle-totals');
  const bundleSubtotalEl = document.getElementById('bsb-cb-bundle-subtotal');
  const bundleMinEl = document.getElementById('bsb-cb-bundle-min');
  const bundleMinValueEl = document.getElementById('bsb-cb-bundle-min-value');
  const bundleMinFillEl = document.getElementById('bsb-cb-bundle-min-fill');
  const bundleMinHelperEl = document.getElementById('bsb-cb-bundle-min-helper');
  const tabs = document.querySelectorAll('.bsb-cb__tab');
  const tabPanels = document.querySelectorAll('.bsb-cb__tab-panel');

  /* Editor enters the minimum in dollars when bundleMinMode is "amount".
     Internally everything is tracked in cents (item.price is cents), so
     the dollar minimum is converted once here. */
  const unitScale = bundleMinMode === 'amount' ? 100 : 1;
  const bundleMin = (bundleMinEl ? parseInt(bundleMinEl.dataset.min, 10) : 2) * unitScale;

  /* bundle item: { id, variantId, sport, size, qty, price, display, doubleSided,
                    text, textFont, textColor, logoFile, logoName } */
  const bundle = [];
  let bundleItemSeq = 0;
  let prevMinimumMet = false;

  const BALL_WIDTHS = [400, 600, 900, 1200];
  const ballImageCache = {};

  const state = {
    sport: data.currentSport || null,
    size: data.currentSize || null,
    display: 'ground',
    doubleSided: false,
    text: '',
    textFont: 'Inter',
    textColor: '#ffffff',
    textSize: 32,
    textX: 50,
    textY: 50,
    logoImg: null,
    logoFile: null,
    logoPreviewUnsupported: false,
    logoSize: 50,
    logoX: 50,
    logoY: 50,
    qty: 1,
    showSafeZone: false,
    dragging: null,
  };

  function activeSport() {
    return sportsFieldset && sportsFieldset.querySelector('input[name="bsb-cb-sport"]:checked');
  }

  function activeSize() {
    return sizesFieldset && sizesFieldset.querySelector('input[name="bsb-cb-size"]:checked');
  }

  function findVariant(sport, size) {
    return variants.find((v) => {
      if (sportPos && v['option' + sportPos] !== sport) return false;
      if (sizePos && v['option' + sizePos] !== size) return false;
      return true;
    }) || null;
  }

  function loadBallImage(input) {
    if (!input) return;
    const cacheKey = input.value;
    if (ballImageCache[cacheKey]) {
      render();
      return;
    }
    const url = input.getAttribute('data-ball-image-900') || input.getAttribute('data-ball-image-1200');
    if (!url) return;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      ballImageCache[cacheKey] = img;
      if (activeSport() === input) render();
    };
    img.src = url;
  }

  function getUnitPrice() {
    const sportInput = activeSport();
    const sizeInput = activeSize();
    if (!sportInput || !sizeInput) return 0;
    const variant = findVariant(sportInput.value, sizeInput.value);
    if (!variant) return 0;
    let price = variant.price / 100;
    if (state.display === 'both') price *= 1 + bothSidesPct / 100;
    if (state.doubleSided) price *= 1 + doubleSidedPct / 100;
    return Math.round(price);
  }

  function formatPrice(amount) {
    return `$${amount.toLocaleString()}.00`;
  }

  function updatePrice() {
    const unit = getUnitPrice();
    const total = unit * state.qty;
    if (priceEl) priceEl.textContent = formatPrice(unit);
    if (totalPriceEl) totalPriceEl.textContent = formatPrice(total);
  }

  /* ── Preview PNG + spec text ─────────────────────────────────────
     Called at "Add to Bundle" time, before resetCustomization() wipes state.
     capturePreviewPng() exports the current canvas as a PNG File.
     buildSpecText() assembles a human-readable spec string stored as a
     plain text line item property so the print shop can copy-paste it. ── */

  function capturePreviewPng(sport, size) {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) { resolve(null); return; }
        const safeSport = sport.replace(/[^a-z0-9]/gi, '-').toLowerCase();
        const safeSize  = size.replace(/[^a-z0-9]/gi, '-').toLowerCase();
        const date = new Date().toISOString().slice(0, 10);
        resolve(new File([blob], `preview-${safeSport}-${safeSize}-${date}.png`, { type: 'image/png' }));
      }, 'image/png');
    });
  }

  function buildSpecText(item) {
    const date = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    const lines = [
      `Date: ${date}`,
      `Variant: ${item.sport} / ${item.size}`,
      `Display Method: ${displayLabels[item.display] || item.display}`,
      `Double-Sided: ${item.doubleSided ? `Yes (+${doubleSidedPct}%)` : 'No'}`,
      `Text: ${item.text || '(none)'}`,
      `Font: ${item.text ? item.textFont : '—'}`,
      `Text Color: ${item.text ? item.textColor : '—'}`,
      `Logo: ${item.logoName || '(none)'}`,
      `Quantity: ${item.qty}`,
    ];
    return lines.join('\n');
  }

  /* ── Bundle ───────────────────────────────────────────────────────
     Each "Add to Bundle" snapshots the current configuration (sport,
     size, qty, customization) as one line item. Multiple items combine
     into one batched /cart/add.js call. Tier progress + minimum gate
     are tracked by qty or $ amount (bundleMinMode), set by the editor. ── */

  function escapeHtml(s) {
    if (!s) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function bundleTotalQty() {
    return bundle.reduce((sum, item) => sum + item.qty, 0);
  }

  function bundleSubtotal() {
    return bundle.reduce((sum, item) => sum + item.price * item.qty, 0);
  }

  /* Cached cart totals (qty + price-in-cents), refreshed async via
     refreshCartTotals(). Lets bundleProgressValue() count the customer's
     ENTIRE cart (any product, not just this one) toward the minimum —
     client confirmed (2026-06-23) other items in cart should count too,
     not just this product's variants. Also covers the partial Add to
     Cart failure case: leftover bundle items shouldn't be blocked by the
     minimum if the customer's cart already clears it. */
  const cartTotals = { qty: 0, amount: 0 };

  function applyCartState(cart) {
    const items = cart.items || [];
    cartTotals.qty = items.reduce((sum, line) => sum + line.quantity, 0);
    cartTotals.amount = items.reduce((sum, line) => sum + line.line_price, 0);
    renderBundle();
  }

  function refreshCartTotals() {
    const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? `${window.Shopify.routes.root}cart.js`
      : '/cart.js';
    return fetch(cartUrl)
      .then((r) => r.json())
      .then(applyCartState)
      .catch(() => {});
  }

  /* Dawn's cart.js dispatches cart:change on the document whenever the
     native cart drawer/page changes the cart (e.g. removing a line item),
     so the bar stays in sync without a manual refresh or page reload. */
  document.addEventListener('cart:change', (e) => {
    if (e.detail && e.detail.cart) applyCartState(e.detail.cart);
  });

  function bundleProgressValue() {
    const bundleValue = bundleMinMode === 'amount' ? bundleSubtotal() : bundleTotalQty();
    const cartValue = bundleMinMode === 'amount' ? cartTotals.amount : cartTotals.qty;
    return bundleValue + cartValue;
  }

  function bundleMinimumMet() {
    return bundleProgressValue() >= bundleMin;
  }

  function formatBundleValue(n) {
    return bundleMinMode === 'amount' ? formatPrice(n / 100) : `${n}`;
  }

  function hasLogoAndText() {
    return !!(state.logoFile || state.logoPreviewUnsupported) && !!state.text;
  }

  function showConflict() {
    if (conflictEl) conflictEl.hidden = false;
  }

  function hideConflict() {
    if (conflictEl) conflictEl.hidden = true;
  }

  if (conflictKeepLogoBtn) conflictKeepLogoBtn.addEventListener('click', clearText);
  if (conflictKeepTextBtn) conflictKeepTextBtn.addEventListener('click', clearLogo);

  async function addCurrentToBundle() {
    if (hasLogoAndText()) {
      showConflict();
      return;
    }
    hideConflict();

    const sportInput = activeSport();
    const sizeInput = activeSize();
    const variant = sportInput && sizeInput ? findVariant(sportInput.value, sizeInput.value) : null;
    if (!variant || !addToBundleBtn) return;

    bundleItemSeq += 1;

    const item = {
      id: bundleItemSeq,
      variantId: variant.id,
      sport: sportInput.value,
      size: sizeInput.value,
      qty: state.qty,
      price: getUnitPrice() * 100,
      display: state.display,
      doubleSided: state.doubleSided,
      text: state.text,
      textFont: state.textFont,
      textColor: state.textColor,
      textX: state.textX,
      textY: state.textY,
      textSize: state.textSize,
      logoFile: state.logoFile,
      logoName: state.logoFile ? state.logoFile.name : '',
      logoX: state.logoX,
      logoY: state.logoY,
      logoSize: state.logoSize,
      ballImage: (ballImageCache[sportInput.value] || {}).src || '',
    };

    item.previewPngFile = await capturePreviewPng(item.sport, item.size);
    item.specText = buildSpecText(item);

    bundle.push(item);
    resetCustomization();
    updatePrice();
    renderBundle();
  }

  function resetCustomization() {
    state.qty = 1;
    state.display = 'ground';
    state.doubleSided = false;
    state.showSafeZone = false;

    if (qtyInput) qtyInput.value = 1;
    if (displayMethodSelect) displayMethodSelect.value = 'ground';
    if (displayNoteEl) displayNoteEl.textContent = (displayNotes.ground || '').replace('{pct}', bothSidesPct);
    if (doubleSidedToggle) doubleSidedToggle.checked = false;
    if (safeZoneToggle) safeZoneToggle.checked = false;

    clearLogo();
    clearText();
  }

  function removeFromBundle(itemId) {
    const idx = bundle.findIndex((item) => item.id === itemId);
    if (idx >= 0) {
      bundle.splice(idx, 1);
      renderBundle();
    }
  }

  function changeBundleQty(itemId, delta) {
    const item = bundle.find((i) => i.id === itemId);
    if (!item) return;
    item.qty = Math.max(1, item.qty + delta);
    renderBundle();
  }

  function renderBundleList() {
    if (!bundleListEl) return;

    if (bundle.length === 0) {
      bundleListEl.innerHTML = '<li class="bsb-cb__bundle-empty" id="bsb-cb-bundle-empty">Add your first ball to start the bundle.</li>';
      return;
    }

    bundleListEl.innerHTML = bundle.map((item) => {
      const swatchStyle = item.ballImage ? `background-image:url(${item.ballImage});` : '';
      const metaParts = [item.sport, item.size];
      if (item.doubleSided) metaParts.push('Double-sided');
      if (item.text) metaParts.push('Text');
      if (item.logoName) metaParts.push('Logo');
      return (
        '<li class="bsb-cb__bundle-item">' +
          `<span class="bsb-cb__bundle-item-swatch" style="${swatchStyle}" aria-hidden="true"></span>` +
          '<div class="bsb-cb__bundle-item-info">' +
            `<div class="bsb-cb__bundle-item-name">${escapeHtml(item.sport)} — ${escapeHtml(item.size)}</div>` +
            `<div class="bsb-cb__bundle-item-meta">${escapeHtml(metaParts.join(' · '))}</div>` +
          '</div>' +
          '<div class="bsb-cb__bundle-item-qty">' +
            `<button type="button" class="bsb-cb__bundle-item-qty-btn" data-action="dec" data-item-id="${item.id}" aria-label="Decrease quantity">−</button>` +
            `<span class="bsb-cb__bundle-item-qty-val">${item.qty}</span>` +
            `<button type="button" class="bsb-cb__bundle-item-qty-btn" data-action="inc" data-item-id="${item.id}" aria-label="Increase quantity">+</button>` +
          '</div>' +
          `<span class="bsb-cb__bundle-item-price">${formatPrice(item.price * item.qty / 100)}</span>` +
          `<button type="button" class="bsb-cb__bundle-item-remove" data-action="remove" data-item-id="${item.id}" aria-label="Remove from bundle">✕</button>` +
        '</li>'
      );
    }).join('');
  }

  function renderBundleMin() {
    if (!bundleMinEl) return;
    const n = bundleProgressValue();
    const met = bundleMinimumMet();
    const fillPct = bundleMin > 0 ? Math.min(n / bundleMin, 1) * 100 : 100;

    if (bundleMinFillEl) {
      bundleMinFillEl.style.width = `${fillPct}%`;
      bundleMinFillEl.classList.toggle('bsb-cb__bundle-min-fill--met', met);
    }
    if (bundleMinValueEl) {
      bundleMinValueEl.textContent = `${formatBundleValue(n)} of ${formatBundleValue(bundleMin)}`;
    }
    if (bundleMinHelperEl) {
      if (met) {
        bundleMinHelperEl.textContent = '';
      } else {
        const remaining = bundleMin - n;
        bundleMinHelperEl.textContent = bundleMinMode === 'amount'
          ? `Add ${formatBundleValue(remaining)} more to unlock checkout`
          : `Add ${remaining} more ${remaining === 1 ? 'ball' : 'balls'} to unlock checkout`;
      }
    }
  }

  function renderBundleTotals() {
    const n = bundleTotalQty();
    const sub = bundleSubtotal();

    if (bundleTotalsEl) {
      if (n === 0) bundleTotalsEl.setAttribute('hidden', '');
      else bundleTotalsEl.removeAttribute('hidden');
    }
    if (bundleSubtotalEl) bundleSubtotalEl.textContent = formatPrice(sub / 100);
  }

  function renderBundleAtc() {
    if (!atcBtn) return;
    atcBtn.disabled = bundle.length === 0 || !bundleMinimumMet();
  }

  function renderBundleCount() {
    if (!bundleCountEl) return;
    const n = bundleTotalQty();
    bundleCountEl.textContent = n === 0 ? 'Empty' : `${n} ball${n === 1 ? '' : 's'}`;
  }

  function maybeBurstConfetti() {
    const met = bundleMinimumMet();
    if (met === prevMinimumMet) return;
    prevMinimumMet = met;
    if (!met || typeof window.bsbConfetti !== 'function' || !atcBtn) return;
    const rect = atcBtn.getBoundingClientRect();
    window.bsbConfetti(80, rect.left + rect.width / 2, rect.top + rect.height / 2);
  }

  function renderBundle() {
    renderBundleList();
    renderBundleMin();
    renderBundleTotals();
    renderBundleAtc();
    renderBundleCount();
    maybeBurstConfetti();
  }

  if (addToBundleBtn) {
    addToBundleBtn.addEventListener('click', addCurrentToBundle);
  }

  if (bundleListEl) {
    bundleListEl.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-action]');
      if (!btn) return;
      const itemId = parseInt(btn.dataset.itemId, 10);
      if (!itemId) return;
      if (btn.dataset.action === 'inc') changeBundleQty(itemId, 1);
      if (btn.dataset.action === 'dec') changeBundleQty(itemId, -1);
      if (btn.dataset.action === 'remove') removeFromBundle(itemId);
    });
  }

  /* Returns false (and draws nothing) if the wrapped text can't fit within
     maxHeight — caller's circle is too small for the message to be legible,
     so it's better to show nothing than overflow the shape. */
  function wrapText(context, text, cx, cy, maxWidth, lineHeight, maxHeight) {
    const words = text.split(' ');
    const lines = [];
    let line = '';
    words.forEach((word) => {
      const test = line ? `${line} ${word}` : word;
      if (context.measureText(test).width > maxWidth && line) {
        lines.push(line);
        line = word;
      } else {
        line = test;
      }
    });
    if (line) lines.push(line);

    const totalH = lines.length * lineHeight;
    if (maxHeight != null && totalH > maxHeight) return false;

    const startY = cy - totalH / 2 + lineHeight / 2;
    lines.forEach((l, i) => context.fillText(l, cx, startY + i * lineHeight));
    return true;
  }

  function render() {
    const w = canvas.width;
    const h = canvas.height;
    ctx.clearRect(0, 0, w, h);

    const sportInput = activeSport();
    const img = sportInput ? ballImageCache[sportInput.value] : null;
    if (img) {
      const scale = Math.min(w / img.width, h / img.height);
      const iw = img.width * scale;
      const ih = img.height * scale;
      ctx.drawImage(img, (w - iw) / 2, (h - ih) / 2, iw, ih);
    } else {
      ctx.fillStyle = '#ddd';
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, w * 0.38, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#999';
      ctx.font = '24px Inter';
      ctx.textAlign = 'center';
      ctx.fillText(sportInput ? sportInput.value : '', w / 2, h / 2);
    }

    if (state.showSafeZone) {
      ctx.save();
      ctx.strokeStyle = 'rgba(220,38,38,0.85)';
      ctx.setLineDash([8, 6]);
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.arc(w / 2, h / 2, w * 0.3116, 0, Math.PI * 2);
      ctx.stroke();
      ctx.restore();
    }

    if (state.logoImg) {
      const maxSize = w * 0.5 * (state.logoSize / 100);
      const lw = state.logoImg.width;
      const lh = state.logoImg.height;
      const scale = Math.min(maxSize / lw, maxSize / lh);
      const dw = lw * scale;
      const dh = lh * scale;
      const lx = (state.logoX / 100) * w - dw / 2;
      const ly = (state.logoY / 100) * h - dh / 2;
      ctx.drawImage(state.logoImg, lx, ly, dw, dh);
    } else if (state.logoPreviewUnsupported) {
      /* No real image to draw — stand-in circle the customer can still
         drag/resize to indicate where the (unrenderable) logo goes. Radius
         is capped at the print safe zone (w * 0.3116) since artwork outside
         it wouldn't print reliably anyway. */
      const safeZoneRadius = w * 0.3116;
      const radius = safeZoneRadius * (state.logoSize / 100);
      const cx = (state.logoX / 100) * w;
      const cy = (state.logoY / 100) * h;
      ctx.save();
      ctx.fillStyle = 'rgba(0,0,0,0.55)';
      ctx.beginPath();
      ctx.arc(cx, cy, radius, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const fontSize = Math.min(18, radius * 0.2);
      if (fontSize >= 7) {
        ctx.font = `600 ${fontSize}px Inter`;
        const maxTextWidth = radius * 1.7;
        const maxTextHeight = radius * 1.6;
        wrapText(ctx, logoPreviewUnsupportedMessage, cx, cy, maxTextWidth, fontSize * 1.25, maxTextHeight);
      }
      ctx.restore();
    }

    if (state.text) {
      ctx.save();
      ctx.font = `${state.textSize}px '${state.textFont}'`;
      ctx.fillStyle = state.textColor;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      const lines = state.text.split('\n');
      const lineHeight = state.textSize * 1.2;
      const totalH = lines.length * lineHeight;
      const tx = (state.textX / 100) * w;
      const ty = (state.textY / 100) * h - totalH / 2 + lineHeight / 2;
      lines.forEach((line, i) => {
        ctx.fillText(line, tx, ty + i * lineHeight);
      });
      ctx.restore();
    }
  }

  /* ── Sport / Size selection ──────────────────────────────────────
     Size radios are rendered once (deduped by value, assumes every
     Sport has the same Size set — same assumption bsb-product-info
     makes for Color×Size). On Sport change, JS updates each Size
     radio's data-variant-id/data-price in place, mirroring
     bsb-product-info.js's updateSizePrices. No DOM rebuild. ── */

  function updateSizesForSport(sportValue) {
    if (!sizesFieldset || !sportPos) return;
    sizesFieldset.querySelectorAll('.bsb-cb__size-input').forEach((sizeInput) => {
      const match = findVariant(sportValue, sizeInput.value);
      if (!match) return;
      sizeInput.setAttribute('data-variant-id', match.id);
      sizeInput.setAttribute('data-price', match.price);
    });
    updatePrice();
  }

  function onSportChange(input) {
    loadBallImage(input);
    updateSizesForSport(input.value);
    render();
  }

  function onSizeChange() {
    updatePrice();
    render();
  }

  document.addEventListener('change', (e) => {
    if (e.target.name === 'bsb-cb-sport') onSportChange(e.target);
    if (e.target.name === 'bsb-cb-size') onSizeChange();
  });

  /* ── Tabs ───────────────────────────────────────────────────────
     Logo and text are mutually exclusive customization methods —
     switching tabs clears whatever was set on the one being left, so
     there's never ambiguity about which one actually gets submitted. ── */

  function clearLogo() {
    state.logoImg = null;
    state.logoFile = null;
    state.logoPreviewUnsupported = false;
    if (fileInput) fileInput.value = '';
    if (uploadArea) uploadArea.classList.remove('bsb-cb__upload-area--has-file');
    if (uploadPreview) uploadPreview.style.display = 'none';
    if (fileQualityEl) fileQualityEl.textContent = '';
    if (logoControls) logoControls.classList.remove('bsb-cb__logo-controls--visible');
    setThumb('');
    hideConflict();
    render();
  }

  function clearText() {
    state.text = '';
    state.textFont = 'Inter';
    state.textColor = '#ffffff';
    state.textSize = 32;
    if (textInput) textInput.value = '';
    if (fontSelect) fontSelect.value = 'Inter';
    if (textColorInput) textColorInput.value = '#ffffff';
    if (textSizeInput) textSizeInput.value = 32;
    hideConflict();
    render();
  }

  function activateTab(tab, { focus } = {}) {
    tabs.forEach((t) => {
      const active = t === tab;
      t.classList.toggle('bsb-cb__tab--active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      t.setAttribute('tabindex', active ? '0' : '-1');
    });
    tabPanels.forEach((p) => { p.hidden = true; });
    const panel = document.getElementById(`bsb-cb-tab-${tab.dataset.tab}`);
    if (panel) panel.hidden = false;
    if (focus) tab.focus();
  }

  const tabsArr = Array.from(tabs);
  tabsArr.forEach((tab, i) => {
    tab.addEventListener('click', () => activateTab(tab));
    tab.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      const next = e.key === 'ArrowRight'
        ? tabsArr[(i + 1) % tabsArr.length]
        : tabsArr[(i - 1 + tabsArr.length) % tabsArr.length];
      activateTab(next, { focus: true });
    });
  });

  /* ── Print options ───────────────────────────────────────────── */

  if (doubleSidedToggle) {
    doubleSidedToggle.addEventListener('change', (e) => {
      state.doubleSided = e.target.checked;
      updatePrice();
    });
  }

  if (displayMethodSelect) {
    displayMethodSelect.addEventListener('change', (e) => {
      state.display = e.target.value;
      if (displayNoteEl) {
        const note = displayNotes[state.display] || '';
        displayNoteEl.textContent = note.replace('{pct}', bothSidesPct);
      }
      updatePrice();
      render();
    });
  }

  if (safeZoneToggle) {
    safeZoneToggle.addEventListener('change', (e) => {
      state.showSafeZone = e.target.checked;
      render();
    });
  }

  /* ── Text controls ───────────────────────────────────────────── */

  if (textInput) textInput.addEventListener('input', (e) => { state.text = e.target.value; if (!hasLogoAndText()) hideConflict(); render(); });
  if (fontSelect) fontSelect.addEventListener('change', (e) => { state.textFont = e.target.value; render(); });
  if (textColorInput) textColorInput.addEventListener('input', (e) => { state.textColor = e.target.value; render(); });
  if (textSizeInput) textSizeInput.addEventListener('input', (e) => { state.textSize = parseInt(e.target.value, 10); render(); });

  /* ── File upload ─────────────────────────────────────────────── */

  /* Shows the real image thumb (PDF render or raster file) when a dataUrl is
     given, or falls back to a generic file icon for formats with no in-browser
     preview (EPS, AI — no JS decoder exists for these). */
  function setThumb(dataUrl) {
    if (previewThumb) previewThumb.hidden = !dataUrl;
    if (previewThumb && dataUrl) previewThumb.src = dataUrl;
    if (previewIcon) previewIcon.hidden = !!dataUrl;
  }

  function handleFile() {
    const file = fileInput.files[0];
    if (!file) return;
    state.logoFile = file;

    const ext = file.name.split('.').pop().toLowerCase();

    if (fileQualityEl) {
      if (['svg', 'ai', 'eps', 'pdf'].includes(ext)) {
        fileQualityEl.className = 'bsb-cb__file-quality bsb-cb__file-quality--vector';
        fileQualityEl.textContent = '✓ Vector file — excellent print quality';
      } else {
        fileQualityEl.className = 'bsb-cb__file-quality bsb-cb__file-quality--raster';
        fileQualityEl.textContent = 'Raster file — vector preferred for best results';
      }
    }

    state.logoImg = null;
    state.logoPreviewUnsupported = false;

    if (ext === 'pdf') {
      loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js').then(() => {
        window.pdfjsLib.getDocument(URL.createObjectURL(file)).promise.then((pdf) => {
          pdf.getPage(1).then((page) => {
            const vp = page.getViewport({ scale: 2 });
            const c = document.createElement('canvas');
            c.width = vp.width;
            c.height = vp.height;
            page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise.then(() => {
              const dataUrl = c.toDataURL();
              const img = new Image();
              img.onload = () => { state.logoImg = img; render(); };
              img.src = dataUrl;
              setThumb(dataUrl);
            });
          });
        });
      }).catch((err) => {
        console.error('[bsb-cb] Failed to load pdf.js', err);
      });
    } else if (['svg', 'png', 'jpg', 'jpeg', 'gif'].includes(ext)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => { state.logoImg = img; render(); };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

      const tr = new FileReader();
      tr.onload = (e2) => { setThumb(e2.target.result); };
      tr.readAsDataURL(file);
    } else {
      /* AI / EPS — no in-browser decoder exists for either format. The file
         is still uploaded and used for printing; only the live preview is
         unavailable, shown via a message drawn on the canvas instead. */
      state.logoPreviewUnsupported = true;
      setThumb('');
      render();
    }

    if (uploadArea) uploadArea.classList.add('bsb-cb__upload-area--has-file');
    if (uploadPreview) uploadPreview.style.display = 'flex';
    if (fileNameEl) fileNameEl.textContent = file.name;
    /* Size slider + drag-to-reposition apply to the real logo image, or to
       the placeholder box stand-in for AI/EPS uploads — shown either way. */
    if (logoControls) logoControls.classList.add('bsb-cb__logo-controls--visible');
  }

  if (fileInput) fileInput.addEventListener('change', handleFile);

  if (uploadArea) {
    uploadArea.addEventListener('dragover', (e) => {
      e.preventDefault();
      uploadArea.classList.add('bsb-cb__upload-area--dragover');
    });
    uploadArea.addEventListener('dragleave', () => {
      uploadArea.classList.remove('bsb-cb__upload-area--dragover');
    });
    uploadArea.addEventListener('drop', (e) => {
      e.preventDefault();
      uploadArea.classList.remove('bsb-cb__upload-area--dragover');
      if (e.dataTransfer.files[0]) {
        fileInput.files = e.dataTransfer.files;
        handleFile();
      }
    });
  }

  if (removeFileBtn) {
    removeFileBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      clearLogo();
    });
  }

  if (logoSizeInput) {
    logoSizeInput.addEventListener('input', (e) => {
      state.logoSize = parseInt(e.target.value, 10);
      if (logoSizeLabel) logoSizeLabel.textContent = `${state.logoSize}%`;
      render();
    });
  }

  /* ── Quantity ─────────────────────────────────────────────────── */

  if (qtyMinus) {
    qtyMinus.addEventListener('click', () => {
      if (state.qty > 1) {
        state.qty -= 1;
        qtyInput.value = state.qty;
        updatePrice();
      }
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => {
      state.qty += 1;
      qtyInput.value = state.qty;
      updatePrice();
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', (e) => {
      state.qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      e.target.value = state.qty;
      updatePrice();
    });
  }

  /* ── Canvas drag (logo / text reposition) ────────────────────── */

  function startDrag(x, y) {
    const px = (x / canvas.clientWidth) * 100;
    const py = (y / canvas.clientHeight) * 100;
    if (state.logoImg || state.logoPreviewUnsupported) {
      const dx = Math.abs(px - state.logoX);
      const dy = Math.abs(py - state.logoY);
      if (dx < 20 && dy < 20) { state.dragging = 'logo'; return; }
    }
    if (state.text) {
      const dx = Math.abs(px - state.textX);
      const dy = Math.abs(py - state.textY);
      if (dx < 20 && dy < 20) { state.dragging = 'text'; }
    }
  }

  function moveDrag(x, y) {
    if (!state.dragging) return;
    const px = Math.max(5, Math.min(95, (x / canvas.clientWidth) * 100));
    const py = Math.max(5, Math.min(95, (y / canvas.clientHeight) * 100));
    if (state.dragging === 'logo') { state.logoX = px; state.logoY = py; }
    else if (state.dragging === 'text') { state.textX = px; state.textY = py; }
    render();
  }

  canvas.addEventListener('mousedown', (e) => startDrag(e.offsetX, e.offsetY));
  canvas.addEventListener('mousemove', (e) => moveDrag(e.offsetX, e.offsetY));
  canvas.addEventListener('mouseup', () => { state.dragging = null; });
  canvas.addEventListener('touchstart', (e) => {
    e.preventDefault();
    const t = e.touches[0];
    const r = canvas.getBoundingClientRect();
    startDrag(t.clientX - r.left, t.clientY - r.top);
  });
  canvas.addEventListener('touchmove', (e) => {
    e.preventDefault();
    const t = e.touches[0];
    const r = canvas.getBoundingClientRect();
    moveDrag(t.clientX - r.left, t.clientY - r.top);
  });
  canvas.addEventListener('touchend', () => { state.dragging = null; });

  /* ── Add bundle to cart ──────────────────────────────────────────
     Each bundle item is submitted as its own native multipart POST to
     /cart/add.js (sequential, not batched). Logo files ride along as a
     real FormData file field — Shopify uploads and hosts them itself
     (CDN URL attached to the line item property automatically), so no
     third-party upload service or its CORS/timeout issues are involved.
     Sequential submission also avoids concurrent-write races against the
     cart and lets a failure on one item leave the rest already added. ── */

  const displayLabels = {
    ground: 'Ground/Pool — D-ring bottom',
    hanging: 'Hanging — D-ring top',
    both: 'Both — D-ring top + bottom',
  };

  function buildItemFormData(item) {
    const formData = new FormData();
    formData.append('id', item.variantId);
    formData.append('quantity', item.qty);
    formData.append('properties[Display]', displayLabels[item.display] || '');
    if (item.doubleSided) formData.append('properties[Double-Sided Print]', `Yes (+${doubleSidedPct}%)`);
    if (item.text) formData.append('properties[Text]', `${item.text} — ${item.textFont}, ${item.textColor}`);
    if (item.logoFile) formData.append('properties[Logo File]', item.logoFile, item.logoFile.name);
    if (item.previewPngFile) formData.append('properties[Preview]', item.previewPngFile, item.previewPngFile.name);
    if (item.specText) formData.append('properties[_spec]', item.specText);

    return formData;
  }

  async function addItemToCart(item) {
    const body = buildItemFormData(item);
    const resp = await fetch('/cart/add.js', {
      method: 'POST',
      body,
    });
    const result = await resp.json();
    if (!resp.ok) throw new Error((result && result.description) || 'Failed to add item');
    return result;
  }

  function refreshCartUI() {
    const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? `${window.Shopify.routes.root}cart.js`
      : '/cart.js';
    fetch(cartUrl).then((r) => r.json()).then((cart) => {
      document.querySelectorAll('.cart-count-bubble span, .icon-cart-ball__count')
        .forEach((el) => { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart } }));
    }).catch(() => {});
  }

  if (atcBtn) {
    atcBtn.addEventListener('click', async function onAtc() {
      if (bundle.length === 0) return;

      const originalText = atcBtn.textContent;
      atcBtn.disabled = true;

      const total = bundle.length;
      const failed = [];
      let addedCount = 0;
      let lastResult = null;

      for (let i = 0; i < bundle.length; i += 1) {
        atcBtn.textContent = total > 1 ? `Adding ${i + 1} of ${total}...` : 'Adding...';
        try {
          lastResult = await addItemToCart(bundle[i]);
          addedCount += 1;
        } catch (err) {
          console.error('[bsb-cb] Failed to add bundle item', err, bundle[i]);
          failed.push(bundle[i]);
        }
      }

      if (addedCount > 0) {
        refreshCartUI();
        refreshCartTotals();
      }

      if (failed.length === 0) {
        atcBtn.textContent = 'Added ✓';
        atcBtn.classList.add('bsb-cb__atc--success');
        setTimeout(() => {
          bundle.length = 0;
          prevMinimumMet = false;
          renderBundle();
          atcBtn.textContent = originalText;
          atcBtn.classList.remove('bsb-cb__atc--success');
        }, 1500);
      } else {
        /* Leave only the failed items in the bundle so retrying doesn't
           re-add what already succeeded. */
        bundle.length = 0;
        bundle.push(...failed);
        renderBundle();
        atcBtn.textContent = addedCount > 0
          ? `${addedCount} added, ${failed.length} failed — Try Again`
          : 'Error — Try Again';
        atcBtn.classList.add('bsb-cb__atc--error');
        setTimeout(() => {
          atcBtn.textContent = 'Add Bundle to Cart';
          atcBtn.classList.remove('bsb-cb__atc--error');
          atcBtn.disabled = bundleProgressValue() < bundleMin;
        }, 3000);
      }
    });
  }

  /* ── Init ─────────────────────────────────────────────────────── */

  let initialSport = activeSport();
  if (!initialSport && sportsFieldset) {
    initialSport = sportsFieldset.querySelector('input[name="bsb-cb-sport"]');
    if (initialSport) initialSport.checked = true;
  }
  if (initialSport) {
    loadBallImage(initialSport);
    updateSizesForSport(initialSport.value);
  }
  updatePrice();
  renderBundle();
  refreshCartTotals();
  render();
})();
